// Light is the default. The choice is kept per browser, and Bootstrap switches its colors with data-bs-theme
const STORAGE_KEY = "theme";

export const getStoredTheme = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
};

export const applyTheme = (theme) => {
  document.documentElement.setAttribute("data-bs-theme", theme);
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // Private windows can block storage, the theme still applies until reload
  }
};
